<template>
<div>
  <div v-for="(item, index) in desserts" :key="index" style="padding: 20px; border-bottom: 1px solid #ccc;">
    <h3 style="display: flex; align-items: center; column-gap: 10px">
      <span>Площадка:</span>
      <span v-if="item.site && item.site.name"
        ><a :href="item.site.name" target="_blank">{{
          item.site.name
        }}</a></span
      >
    </h3>
    <div class="flexs">
      <RateBlock
        :rate="item.rate"
        title=""
        :avarege="CalculateAvaregeRate(item.rate)"
        :makeRate="false"
      />
      <v-textarea
        prepend-icon="comment"
        type="text"
        label="Оставленный комментарий"
        readonly
        v-model="item.comment"
        :rows="3"
      />
    </div>
    <div class="flexs" style="justify-content: space-between;">
      <div>
        <div class="flexs">
        <span><strong>Пользователь</strong>: {{item.user.name}}</span>
        <span><strong>Почта</strong>: {{item.user.email}}</span>
        </div>
        <div class='flexs'>
          <span><strong>Оставлен комментарий</strong>: {{moment(item.created_at).format('HH:mm DD.MM.YYYY')}}</span>
          <span><strong>Изменен комментарий</strong>: {{moment(item.updated_at).format('HH:mm DD.MM.YYYY')}}</span>
        </div>
      </div>
      <Likes
        :bank_id="item.bank_id"
        :product_id="item.product_id"
        :user_id="item.user_id"
        :likes="item.likes.likesCount ? item.likes.likesCount : 0"
        :likesArray="item.likes.likes"
        :useful="item.likes.useful"
        :dislikes="item.likes.dislikesCount ? item.likes.dislikesCount : 0"
        :dislikesArray="item.likes.dislikes"
        disabled
      />
      <v-icon
        style="color: rgba(255, 40, 40, 0.7)"
        class="onHover"
        @click="$emit('removeComment',item)"
        >delete</v-icon
      >
    </div>

  </div>
</div>
</template>
<script>
import moment from 'moment'
import RateBlock from "@/components/Raiting/rateBlock.vue";
import Likes from "@/components/Raiting/Likes.vue";
export default {
  name: "bank_item",
  components: {
    RateBlock,
    Likes,
  },
  data: () => ({
    moment
  }),
  props: {
    desserts: {type: Array, default: ()=>([])}
  },
  methods: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped>
.flexs
  display: flex
  column-gap: 10px
</style>
